/**
 * כותרות טאב הדפדפן (`document.title`) לניווט בצד הלקוח — נמצא 21.08.2026
 * בסבב QA: מעברי עמוד דרך `<Link>`/`navigate()` (⛔ לא רענון מלא) השאירו את
 * הכותרת של העמוד הקודם, כי שום קוד בצד הלקוח מעולם לא קרא ל-`document.title`.
 *
 * ⚠️ **כפילות מכוונת** מול `server/src/lib/seoMeta.ts` (`STATIC_ROUTES`) —
 * אותו דפוס בדיוק כמו `COMPANY_NAME`/`COMPANY_TAGLINE` ב-`businessInfo.ts`
 * (השרת ⛔ אינו תלוי בחבילת ה-client). השרת קובע את הכותרת בטעינה
 * הראשונה/רענון (קריטי לתצוגה מקדימה בוואטסאפ, שלא מריצה JS) — כאן רק
 * מסנכרנים אותה בזמן ניווט פנימי כדי שהיא לא תישאר "תקועה" על עמוד קודם.
 * דף מוצר (כותרת דינמית לפי מוצר) ⛔ אינו כאן - `ProductPage.tsx` קובע
 * את הכותרת שלו בעצמו אחרי טעינת הנתונים.
 */
import { COMPANY_NAME } from './businessInfo.js';

export const STATIC_PAGE_TITLES: Record<string, string> = {
  '/': COMPANY_NAME,
  '/gallery': `גלריה ואודות | ${COMPANY_NAME}`,
  '/contact': `צור קשר | ${COMPANY_NAME}`,
  '/catalog': `קטלוג מוצרים | ${COMPANY_NAME}`,
  '/terms': `תנאי שימוש | ${COMPANY_NAME}`,
  '/privacy': `מדיניות פרטיות | ${COMPANY_NAME}`,
  '/accessibility': `הצהרת נגישות | ${COMPANY_NAME}`,
  '/cart': `עגלת בקשות | ${COMPANY_NAME}`,
  '/request': `בקשת הצעת מחיר | ${COMPANY_NAME}`,
  '/request/thank-you': `הבקשה נשלחה | ${COMPANY_NAME}`,
};
